import { render, staticRenderFns } from "./TemplatePanel.vue?vue&type=template&id=ef667e00&scoped=true&"
import script from "./TemplatePanel.vue?vue&type=script&lang=js&"
export * from "./TemplatePanel.vue?vue&type=script&lang=js&"
import style0 from "./TemplatePanel.vue?vue&type=style&index=0&id=ef667e00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef667e00",
  null
  
)

export default component.exports